import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Overview from "./components/Overview";
import Ending from "./components/Ending";
import Relations from "./components/Relations";
import Characters from "./components/Characters";
import Story from "./components/Story";
import Scenes from "./components/Scenes";
import Themes from "./components/Themes";
import Faq from "./components/Faq";
import Info from "./components/Info";
import CtaBand from "./components/CtaBand";
import Footer from "./components/Footer";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 700);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div id="top" className="w-full bg-background-50 overflow-x-hidden">
      <Navbar />

      <main>
        <Hero />
        <Overview />
        <Ending />
        <Relations />
        <Characters />
        <Story />
        <Scenes />
        <Themes />
        <Faq />
        <Info />
        <CtaBand />
      </main>

      <Footer />

      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="回到顶部"
        className={`fixed right-4 md:right-6 bottom-6 z-40 w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center transition-all duration-300 cursor-pointer hover:bg-primary-600 ${
          showTop ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </button>
    </div>
  );
}